import { render, staticRenderFns } from "./listluarprovinsi.vue?vue&type=template&id=94bed29e&"
import script from "./listluarprovinsi.vue?vue&type=script&lang=js&"
export * from "./listluarprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports